/**
 * Helpers for ChipMultiSelect (id normalization, select-all).
 */

export function normalizeId(id) {
  if (id === undefined || id === null || id === '') return '';
  return String(id);
}

export function getItemValue(item, itemValue) {
  if (item == null) return '';
  if (typeof item !== 'object') return item;
  if (itemValue && item[itemValue] != null) return item[itemValue];
  if (item.id != null) return item.id;
  if (item._id != null) return item._id;
  return '';
}

export function getItemLabel(item, itemText) {
  if (item == null) return '';
  if (typeof item !== 'object') return String(item);
  if (itemText && item[itemText] != null) return String(item[itemText]);
  return String(item.name || item.label || '');
}

export function getAllItemValues(items, itemValue) {
  return (items || []).map((item) => getItemValue(item, itemValue)).filter((id) => id !== '' && id != null);
}

export function isValueSelected(selected, id) {
  const target = normalizeId(id);
  return (selected || []).some((value) => normalizeId(value) === target);
}

export function isAllValuesSelected(selected, allIds) {
  if (!allIds.length) return false;
  return allIds.every((id) => isValueSelected(selected, id));
}

export function toggleSelectAllValues(selected, allIds) {
  return isAllValuesSelected(selected, allIds) ? [] : [...allIds];
}

export function toggleValue(selected, id) {
  const current = [...(selected || [])];
  const index = current.findIndex((value) => normalizeId(value) === normalizeId(id));
  if (index > -1) {
    current.splice(index, 1);
  } else {
    current.push(id);
  }
  return current;
}

export function removeValue(selected, id) {
  return (selected || []).filter((value) => normalizeId(value) !== normalizeId(id));
}
